import Vue from "vue"
import "./plugins/axios"
import App from "./App.vue"
import vuetify from "./plugins/vuetify"
import router from "./router"
import { store } from "./store"
import VueCookies from 'vue-cookies';
import VueSocialSharing from 'vue-social-sharing'


import 'material-design-icons-iconfont/dist/material-design-icons.css'
Vue.config.productionTip = false;

Vue.use(vuetify)
Vue.use(VueCookies);
Vue.use(VueSocialSharing);



new Vue({
  render: h => h(App),
  vuetify,
  store,
  router
  // firebase onAuthStateChanged created ???
  }).$mount("#app");

